<template>
<div id="App">
  <transition
    @enter="enter" @after-enter="afterEnter"
    @leave="leave" @after-leave="afterLeave"
    @before-enter="beforeEnter"
    :css="false" appear :mode="mode">
    <router-view ref="page" />
  </transition>
</div>
</template>

<script>
import Transition from '@/core/mixins/Transition'
import Settings from '@/config/Settings'

export default {
  name: 'App',
  mixins: [ Transition ],
  data: () => ({
    countReload: 0
  }),
  beforeDestroy() {
    document.removeEventListener('touchstart', this.forceReload)
  },
  mounted() {
    if(this.$root.$agent.mobile && Settings.localAssets)
      document.addEventListener('touchstart', this.forceReload)
  },
  methods: {
    forceReload() {
      this.countReload++
      
      if(this.$timerReload)
        this.$timerReload.kill()

      this.$timerReload = TweenLite.delayedCall(.2, () => this.countReload = 0)

      if(this.countReload > 4) {
        this.$router.push({ name: 'load.' + this.lang })
        TweenMax.delayedCall(1, () => location.reload())
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/fonts/Fonts'
@import '~@/commons/stylus/Reset'
@import '~@/commons/stylus/Global'
@import '~@/commons/stylus/Page'

#App
  width 100%
  height 100%
</style>



// WEBPACK FOOTER //
// src/App.vue